var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:{ 'active': _vm.active },on:{"click":function($event){return _vm.clickPageItemHandler(_vm.pageNumber)}}},[_vm._v("Page "+_vm._s(_vm.pageNumber))])}
var staticRenderFns = []

export { render, staticRenderFns }